import React, { useState } from 'react';
import './ShareButton.css'; // Importing the updated CSS

const ShareButton = ({ isMalayalam }) => {
    const [showPopup, setShowPopup] = useState(false);

    const shareMessage = isMalayalam
        ? "പ്രിയ  സഹോദരാ / സഹോദരി,  പാൻക്രിയാസിനെ  ബാധിച്ചിരിക്കുന്ന അർബുദരോഗത്തോട്  മല്ലടിക്കുന്ന വരിക്കമാക്കൽ ജെറോമിനെ  സഹായിക്കാനുള്ള  ഈ  സംരംഭത്തിൽ പങ്കുചേരാൻ താങ്കളെയും ക്ഷണിക്കുന്നു.  എത്ര ചെറിയ സംഭാവനയും ജെറോമിനെയും  കുടുംബത്തേയും സഹായിക്കാൻ  ഉപകരിക്കും.  ദയവായി താഴെ കാണുന്ന ലിങ്കില്‍ ക്ലിക്ക്  ചെയ്‌തു സഹകരിക്കുകയോ അതല്ലെങ്കിൽ മറ്റുളവർക്കു ഈ ലിങ്ക് ഷെയർ ചെയ്യുകയോ ചെയ്യണമെന്ന് അഭ്യർത്ഥിക്കുന്നു."
        : "Hello, I wanted to share something important about Jerome M Varickamackal, who is currently facing a tough battle with 4th stage of pancreatic cancer. Every donation, no matter the size, will really help lessen his financial worries so he can focus on his health and his family. If you’re able, please consider clicking the link below to donate or share it with others who might help.";

    const donationLink = "https://www.support-jerome.org/";
    // const metaImage = "https://www.support-jerome.org/assets/jerome-meta-image.jpg"; // Metadata image URL

    // URL-encode the components for sharing
    const encodedMessage = encodeURIComponent(shareMessage);
    const encodedLink = encodeURIComponent(donationLink);
    const handleShareClick = () => {
        const combinedText = `${shareMessage}\n\n${donationLink}`; // Combine the message and link
        const encodedMessage = encodeURIComponent(shareMessage);
        const encodedLink = encodeURIComponent(donationLink);
        const title = 'Please Support Jerome Fight Against Pancreatic Cancer'; // Custom title

        if (navigator.share) {
            // Use Web Share API for generic sharing
            navigator
                .share({
                    title: title, // Custom title
                    text: combinedText, // Combined message with link
                })
                .then(() => console.log('Share successful'))
                .catch((error) => console.error('Error sharing:', error));
        } else {
            // Fallback logic for unsupported platforms
            if (navigator.userAgent.includes('WhatsApp')) {
                // WhatsApp sharing
                window.open(
                    `https://wa.me/?text=${encodeURIComponent(combinedText)}`,
                    '_blank'
                );
            } else if (navigator.userAgent.includes('Email')) {
                // Email sharing
                window.open(
                    `mailto:?subject=${encodeURIComponent(title)}&body=${encodedMessage}%0A${encodedLink}`,
                    '_blank'
                );
            } else if (navigator.userAgent.includes('Facebook')) {
                // Facebook sharing
                window.open(
                    `https://www.facebook.com/sharer/sharer.php?u=${encodedLink}&quote=${encodedMessage}`,
                    '_blank'
                );
            } else if (navigator.userAgent.includes('Messenger')) {
                // Messenger sharing
                window.open(
                    `https://www.facebook.com/dialog/send?app_id=YOUR_APP_ID&link=${encodedLink}&redirect_uri=${encodedLink}`,
                    '_blank'
                );
            } else if (navigator.userAgent.includes('Twitter')) {
                // Twitter sharing
                window.open(
                    `https://twitter.com/intent/tweet?text=${encodedMessage}&url=${encodedLink}`,
                    '_blank'
                );
            } else if (navigator.userAgent.includes('LinkedIn')) {
                // LinkedIn sharing
                window.open(
                    `https://www.linkedin.com/shareArticle?mini=true&url=${encodedLink}&title=${title}&summary=${encodedMessage}&source=${encodedLink}`,
                    '_blank'
                );
            } else if (navigator.userAgent.includes('Nextdoor')) {
                // Nextdoor sharing
                window.open(
                    `https://nextdoor.com/share?url=${encodedLink}`,
                    '_blank'
                );
            } else {
                // Default fallback for other unsupported platforms
                setShowPopup(true);
            }
        }
    };




    const closePopup = () => {
        setShowPopup(false);
    };

    return (
        <div>
            <button className="btn btn-warning" onClick={handleShareClick}>
                Share<span style={{ marginRight: '1rem' }}></span>
            </button>

            {showPopup && (
                <div className="modal show d-block" role="dialog" aria-hidden="false">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Quick Share</h5>
                                <button type="button" className="close" onClick={closePopup} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={donationLink}
                                        readOnly
                                    />
                                </div>
                                <p>Reach more donors by sharing</p>
                                <p>We’ve written tailored messages and auto-generated posters based on the fundraiser story for you to share</p>

                                <div className="social-buttons">
                                    {/* Facebook */}
                                    <div className="icon-with-label">
                                        <a
                                            href={`https://www.facebook.com/sharer/sharer.php?u=${encodedLink}&quote=${encodedMessage}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="circle-icon"
                                        >
                                            <i className="fab fa-facebook-f"></i>
                                        </a>
                                        <span className="icon-label">Facebook</span>
                                    </div>

                                    {/* Messenger */}
                                    <div className="icon-with-label">
                                        <a
                                            href={`https://www.facebook.com/dialog/send?app_id=YOUR_APP_ID&link=${encodedLink}&redirect_uri=${encodedLink}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="circle-icon"
                                        >
                                            <img
                                                src="/messenger.png"
                                                alt="Share via Messenger"
                                                className="icon-image"
                                            />
                                        </a>
                                        <span className="icon-label">Messenger</span>
                                    </div>

                                    {/* WhatsApp */}
                                    <div className="icon-with-label">
                                        <a
                                            href={`https://wa.me/?text=${encodeURIComponent(shareMessage)}%20${encodeURIComponent(donationLink)}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="circle-icon"
                                        >
                                            <img
                                                src="/whatsapp.png"
                                                alt="WhatsApp"
                                                className="icon-image"
                                            />
                                        </a>
                                        <span className="icon-label">WhatsApp</span>
                                    </div>

                                    {/* Email */}
                                    <div className="icon-with-label">
                                        <a
                                            href={`mailto:?subject=Support%20Jerome&body=${encodedMessage}%0A${encodedLink}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="circle-icon"
                                        >
                                            <i className="fas fa-envelope"></i>
                                        </a>
                                        <span className="icon-label">Email</span>
                                    </div>

                                    {/* Twitter */}
                                    <div className="icon-with-label">
                                        <a
                                            href={`https://twitter.com/intent/tweet?text=${encodedMessage}&url=${encodedLink}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="circle-icon"
                                        >
                                            <img
                                                src="/twitterx.png"
                                                alt="Twitter"
                                                className="icon-image"
                                            />
                                        </a>
                                        <span className="icon-label">X</span>
                                    </div>

                                    {/* LinkedIn */}
                                    <div className="icon-with-label">
                                        <a
                                            href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodedLink}&title=${encodedMessage}&summary=${encodedMessage}&source=${encodedLink}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="circle-icon"
                                        >
                                            <i className="fab fa-linkedin-in"></i>
                                        </a>
                                        <span className="icon-label">LinkedIn</span>
                                    </div>

                                    {/* Nextdoor */}
                                    <div className="icon-with-label">
                                        <a
                                            href={`https://nextdoor.com/share?url=${encodedLink}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="circle-icon"
                                        >
                                            <img
                                                src="/nextdoor.png"
                                                alt="Nextdoor"
                                                className="icon-image"
                                            />
                                        </a>
                                        <span className="icon-label">Nextdoor</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ShareButton;
